// TOPページ

// みんなのベストショットのスライダー
const bsGallery = new Swiper(".p-frontBestshot__slider .swiper", {
  loop: true,
  loopAdditionalSlides: 10,
  speed: 8500,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  allowTouchMove: false,
  slidesPerView: 1.5,
  spaceBetween: 15,

  // ブレークポイント（画面幅による設定）
  breakpoints: {
    // 画面幅が 768px 以上の場合（window width >= 768px）
    768: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    // 画面幅が 1024px 以上の場合（window width >= 1024px）
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 25
    },
    1366: {
      slidesPerView: 4,
    },
    1600: {
      slidesPerView: 5,
    },
  },
});

// ピックアップ情報
// PC3つ並び / TB2つ並び / SP1つ
document.addEventListener('DOMContentLoaded', function () {
  const pickupSliderContainer = document.querySelector(".p-frontPickup .swiper");
  const pickupSlides = pickupSliderContainer.querySelectorAll(".p-frontPickup .swiper-slide");

  if (pickupSlides.length > 3) {
    const pickupSwiper = new Swiper(pickupSliderContainer, {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 18,

      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      },
      navigation: {
        nextEl: ".p-frontPickup .swiper-button-next",
        prevEl: ".p-frontPickup .swiper-button-prev",
      },
    });
  } else {
    pickupSliderContainer.classList.add("is-noSlider");
  }
});
